import React from 'react'
import { Table } from 'semantic-ui-react'

const colors = [

  'green',
  
]

const WeeklyTimeTabel = () => (
  <div>
    {colors.map((color) => (
      <Table color={color} key={color}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>TIME</Table.HeaderCell>
            <Table.HeaderCell>Monday</Table.HeaderCell>
            <Table.HeaderCell>Tuesday</Table.HeaderCell>
            <Table.HeaderCell>Wednesday</Table.HeaderCell>
            <Table.HeaderCell>Thursday</Table.HeaderCell>
            <Table.HeaderCell>Friday</Table.HeaderCell>
            <Table.HeaderCell>Saturday</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Table.Row>
            <Table.Cell>9:00</Table.Cell>
            <Table.Cell>English</Table.Cell>
            <Table.Cell>Maths</Table.Cell>
            <Table.Cell>CAP365</Table.Cell>
            <Table.Cell>CAP387</Table.Cell>
            <Table.Cell>CAP545</Table.Cell>
            <Table.Cell>CAP675</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    ))}
  </div>
)
export default WeeklyTimeTabel
